module.exports = __webpack_public_path__ + "img/133.24826c6c.jpg";